import type { Signal } from '@angular/core';
import { signal } from '@angular/core';

import { createProviderToken } from '@core/common-legacy';
import type { TranslationsRepository } from '@core/i18n-legacy';

export type TellentAssistantMobileTranslationSources = TranslationsRepository[];

export const {
  provide: provideTellentAssistantMobileTranslationSources,
  inject: injectTellentAssistantMobileTranslationSources,
} = createProviderToken<TellentAssistantMobileTranslationSources>(
  'TELLENT_ASSISTANT_MOBILE_TRANSLATION_SOURCES',
)(false);

export interface AssistantModalHandle {
  present: () => Promise<void>;
  dismiss: (data?: unknown, role?: string) => Promise<boolean>;
  onWillDismiss: () => Promise<unknown>;
}

export interface TellentAssistantMobileModalPresenter {
  createCard: (options: {
    component: unknown;
    canDismiss?: boolean;
  }) => Promise<AssistantModalHandle>;
}

export const {
  provide: provideTellentAssistantMobileModalPresenter,
  inject: injectTellentAssistantMobileModalPresenter,
} = createProviderToken<TellentAssistantMobileModalPresenter>(
  'TELLENT_ASSISTANT_MOBILE_MODAL_PRESENTER',
)(false);

export const {
  provide: provideTellentAssistantMobileKeyboardHeight,
  inject: injectTellentAssistantMobileKeyboardHeight,
} = createProviderToken<Signal<number>>('TELLENT_ASSISTANT_MOBILE_KEYBOARD_HEIGHT')(false, {
  providedIn: 'root',
  factory: () => signal(0),
});

export const {
  provide: provideTellentAssistantMobileCompanyKey,
  inject: injectTellentAssistantMobileCompanyKey,
} = createProviderToken<Signal<string | null>>('TELLENT_ASSISTANT_MOBILE_COMPANY_KEY')(false, {
  providedIn: 'root',
  factory: () => signal(null),
});

// Cross-boundary contract for hosts (e.g. manage) whose mobile modal presenter bridges to a
// non-Angular-rendered sheet via plain `window` CustomEvents instead of an AssistantModalHandle
// that actually renders something.
export const TELLENT_ASSISTANT_MOBILE_SHEET_EVENT = <const>{
  open: 'tellent-assistant-mobile:open',
  close: 'tellent-assistant-mobile:close',
};
